export default __webpack_public_path__ + "static/media/head7.b217694d.svg";